import ELEMENT_MATERIALS from '../../../../config/simm/default/element_materials.yml';
import dig from '../dig';

export default function getElementMaterials(issue_location) {
  const defaultElementMaterials = dig(ELEMENT_MATERIALS, 'default_element_materials');
  const elementMaterials = dig(ELEMENT_MATERIALS, 'custom_element_materials', issue_location);

  return elementMaterials || defaultElementMaterials;
};
